import useGoBack from '@/data/hook/useGoBack';
import { useTranslation } from 'react-i18next';
import Text from './dataDisplay/Text';

interface ButtonProps {
  url?: string;
  color?: string;
  hoverColor?: string;
  titleClassName?: string;
}

export default function BackButton(props: ButtonProps) {
  const { t } = useTranslation();

  const { url, color, hoverColor, titleClassName } = props;

  const goBack = useGoBack();
  return (
    <button
      data-testid="backButton"
      id="back-button"
      className={`text-center h-10 w-auto  
      items-center justify-end flex ${color ?? 'text-primary'} hover:${
        hoverColor ?? 'text-primary'
      }`}
      onClick={() => goBack(url)}
    >
      <Text
        format="rubik-500"
        text={t('manageStudent.back')}
        className={titleClassName}
      />
    </button>
  );
}
